import NodeLayer from "./NodeLayer";

class RecStack {
  visited = new Map<NodeLayer, boolean>();
  recursed = new Map<NodeLayer, boolean>();
}

function checkCyclic(layer: NodeLayer, stack: RecStack): boolean {
  // Mark the current node as visited and
  // part of recursion stack
  if (stack.recursed.get(layer) == true) {
    return true;
  }

  if (stack.visited.get(layer) == true) {
    return false;
  }

  stack.visited.set(layer, true);
  stack.recursed.set(layer, true);

  var children = layer.outgoingConnections.map((c) => c.endNode);

  for (var c of children) {
    if (checkCyclic(c, stack)) {
      return true;
    }
  }
  stack.recursed.set(layer, false);

  return false;
}

export function isDirectedCyclic(layer: NodeLayer): boolean {
  var stack = new RecStack();

  return checkCyclic(layer, stack);
}
